import DraftBadge, { useDraftSummaries } from '../DraftBadge';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchOversightConversations, fetchOversightUnreadCounts } from '../store/adminOversightSlice';

const stripHtml = html => (html || '').replace(/<[^>]*>/g, '').trim();

const AdminOversightCoachInboxPage = () => {
  const draftSummaries = useDraftSummaries();
  const dispatch = useDispatch();
  const history = useHistory();
  const { conversations, loading } = useSelector(({ adminOversight }) => adminOversight);

  useEffect(() => {
    dispatch(fetchOversightConversations('coach'));
    dispatch(fetchOversightUnreadCounts());
  }, [dispatch]);

  if (loading && conversations.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>
        Loading conversations...
      </div>
    );
  }

  return (
    <div style={{ padding: '32px 0', minHeight: 'calc(100vh - 160px)' }}>
      <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#1e293b', margin: '0 0 24px' }}>
        Konwersacje trenerów ze sportowcami
      </h1>

      {conversations.length === 0 ? (
        <div
          style={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            padding: '40px',
            textAlign: 'center',
            color: '#64748b',
          }}
        >
          <p style={{ fontSize: '16px', margin: 0 }}>No coach-player conversations found.</p>
        </div>
      ) : (
        <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
          {conversations.map(conv => {
            const coach = conv.coachUserId;
            const player = conv.playerProfileId;
            const coachName = coach ? `${coach.firstName} ${coach.lastName}` : 'Unknown Coach';
            const playerName = player ? `${player.firstName} ${player.lastName}` : 'Unknown Player';
            const lastMsg = conv.lastMessage;
            const unread = conv.unreadCount || 0;
            const isUnread = unread > 0 || conv.markedUnreadByAdmin;

            let senderPrefix = '';
            if (lastMsg) {
              if (lastMsg.senderType === 'coach') senderPrefix = `${coach?.firstName || 'Coach'}: `;
              else if (lastMsg.senderType === 'player') senderPrefix = `${player?.firstName || 'Player'}: `;
              else if (lastMsg.senderType === 'admin') senderPrefix = 'Admin: ';
            }

            return (
              <button
                key={conv._id}
                type="button"
                onClick={() => history.push(`/admin/oversight/coach/${conv._id}`)}
                style={{
                  background: isUnread ? '#e8f0fe' : '#ffffff',
                  border: 'none',
                  borderBottom: '1px solid #f1f5f9',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  textAlign: 'left',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                }}
              >
                <div style={{ width: '18px', flexShrink: 0, color: isUnread ? '#2e496b' : '#cbd5e1' }}>
                  <i className={`fas ${isUnread ? 'fa-bell' : 'fa-bell-slash'}`} />
                </div>
                {/* Participants */}
                <div style={{ width: '240px', flexShrink: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  <span style={{ fontWeight: isUnread ? '700' : '600', fontSize: '14px', color: '#1e293b' }}>
                    {coachName}
                  </span>
                  <span style={{ fontSize: '12px', color: '#94a3b8', margin: '0 4px' }}>↔</span>
                  <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>
                    {playerName}
                  </span>
                </div>
                {/* Preview text */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <DraftBadge summaries={draftSummaries} threadType="conversations" conversationId={conv._id} />
                  {lastMsg && (
                    <span
                      style={{
                        fontSize: '13px',
                        color: isUnread ? '#334155' : '#94a3b8',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        fontWeight: isUnread ? '600' : '400',
                      }}
                    >
                      {senderPrefix}
                      {stripHtml(lastMsg.text)}
                    </span>
                  )}
                </div>
                {/* Date */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  {lastMsg && (
                    <span style={{ fontSize: '11px', color: '#94a3b8', whiteSpace: 'nowrap' }}>
                      {new Date(lastMsg.createdAt).toLocaleDateString([], { month: 'short', day: 'numeric' })}
                    </span>
                  )}
                  {isUnread && (
                    <span
                      style={{
                        background: '#2e496b',
                        color: '#ffffff',
                        borderRadius: '12px',
                        padding: '2px 8px',
                        fontSize: '11px',
                        fontWeight: '700',
                        minWidth: '20px',
                        textAlign: 'center',
                      }}
                    >
                      {unread > 0 ? unread : '●'}
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminOversightCoachInboxPage;
